import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { MapPin, Mail, Clock } from 'lucide-react';

const Contact = () => {
  const { t, language } = useLanguage();

  const labels = {
    en: { 
      contact: 'Contact', 
      officeAddress: 'Office Address', 
      email: 'Email', 
      workingHours: 'Working Hours',
    },
    tr: { 
      contact: 'İletişim', 
      officeAddress: 'Adres', 
      email: 'E-posta', 
      workingHours: 'Çalışma Saatleri',
    },
    es: { 
      contact: 'Contacto', 
      officeAddress: 'Dirección de la Oficina', 
      email: 'Correo', 
      workingHours: 'Horario de Trabajo',
    },
    fr: { 
      contact: 'Contact', 
      officeAddress: 'Adresse du Bureau', 
      email: 'Email', 
      workingHours: 'Heures de Travail',
    },
  };

  const currentLabels = labels[language] || labels.en;

  return (
    <section id="contact" className="relative bg-[#f5f7fa] py-24 lg:py-32">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-[#1e3a5f] font-semibold text-sm uppercase tracking-wider">{currentLabels.contact}</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1e3a5f] mt-4 mb-4" style={{ fontFamily: "'Cardo', Georgia, serif" }}>
            {t('contact.title')}
          </h2>
          <p className="text-xl text-gray-600">
            {t('contact.subtitle')}
          </p>
        </div>

        {/* Contact Details */}
        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 text-center">
            <div className="w-14 h-14 bg-[#f0f4f8] rounded-xl flex items-center justify-center mx-auto mb-4">
              <MapPin className="w-6 h-6 text-[#1e3a5f]" />
            </div>
            <p className="text-[#1e3a5f] font-semibold mb-2">{currentLabels.officeAddress}</p>
            <p className="text-gray-600 text-sm leading-relaxed">
              {t('contact.info.address')}
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 text-center">
            <div className="w-14 h-14 bg-[#f0f4f8] rounded-xl flex items-center justify-center mx-auto mb-4">
              <Mail className="w-6 h-6 text-[#1e3a5f]" />
            </div>
            <p className="text-[#1e3a5f] font-semibold mb-2">{currentLabels.email}</p>
            <a
              href="mailto:info@hh-lawoffice.com"
              className="text-gray-600 text-sm hover:text-[#1e3a5f] transition-colors"
            >
              {t('contact.info.email')}
            </a>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 text-center">
            <div className="w-14 h-14 bg-[#f0f4f8] rounded-xl flex items-center justify-center mx-auto mb-4">
              <Clock className="w-6 h-6 text-[#1e3a5f]" />
            </div>
            <p className="text-[#1e3a5f] font-semibold mb-2">{currentLabels.workingHours}</p>
            <p className="text-gray-600 text-sm">
              {t('contact.info.hours')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
